import { useState } from "react";
import { Modal } from "react-bootstrap";
import { DateRange } from "react-date-range";

export function MyVerticallyCenteredModal(props) {
  const {
    selectedSubject,
    subjectChapters,
    handleSubjectChange,
    toggleDateRange,
    showDateRange,
    dateRangeRef,
    setState,
    state,
    ...modalProps
  } = props;

  // Track which tab is "uploaded"
  const [uploadedTab, setUploadedTab] = useState(null);

  return (
    <Modal
      className="upload-modal"
      {...modalProps}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h4 className="mb-0 fz28 fw800 ff2">Upload Your Assignments</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="other-comp">
          <p className="fz16 fw400">
            — You can now upload your assignments and start working on them
            easily. Stay on track by following just a few simple steps.
          </p>
        </div>

        <div className="main-content">
          <div className="step-card">
            <div className="step-card__label step-card__label--one">
              <span className="ff2 fw400 text">Step</span>
              <span className="ff2 step-number">1</span>
            </div>
            <div className="step-card__info">
              <h5 className="fz16 fw700 ff2">Tell us about your assignment</h5>
              <div className="step-card__info--inner">
                <div className="dropdown">
                  <button
                    className="py-0 border-0 btn btn-solid btn-solid--dark dropdown-toggle"
                    key="uploadSubject"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="fw500 lh1 fz18">
                      {selectedSubject ? selectedSubject : "Subject"}
                    </span>
                    <img
                      className="dd-icon"
                      src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                      alt=""
                    />
                  </button>
                  <div className="mt-1 bdrs10 dropdown-menu ps-3 pt-3 pb-2">
                    <ul className="m-0 ff2 list-unstyled">
                      {Object.keys(subjectChapters)?.map((subject, index) => (
                        <li key={index} className="mb-1">
                          <div className="ps-0 fw500 fz16 checkbox-container">
                            <input
                              id={`sub-${index + 1}`}
                              key={`sub-${index + 1}`}
                              type="radio"
                              name="lang"
                              className="lang-input lang-toggle"
                              value={subject}
                              checked={selectedSubject === subject}
                              onChange={handleSubjectChange}
                            />
                            <label
                              className="text-nowrap"
                              htmlFor={`sub-${index + 1}`}
                              key={`sub-${index + 1}`}
                            >
                              <b />
                              {subject}
                            </label>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <input
                  className="fw500 input-field"
                  type="text"
                  name="topic"
                  placeholder="Topic"
                  id="topic"
                />

                <input
                  className="fw500 input-field"
                  type="text"
                  name="concept"
                  placeholder="Concept (optional)"
                  id="concept"
                />
              </div>
            </div>
          </div>

          <div className="step-card">
            <div className="step-card__label step-card__label--two">
              <span className="ff2 fw400 text">Step</span>
              <span className="ff2 step-number">2</span>
            </div>
            <div className="step-card__info">
              <h5 className="fz16 fw700 ff2 mb-0">
                Upload Your Assignment
                <div className="position-relative shrink-0">
                  <button
                    className="p-0 border-0 btn btn-round--navy bg-dark calendar-white-input"
                    id="datepicker"
                    onClick={toggleDateRange}
                  >
                    <img
                      src="./assets/images/inner-pages/icons/icon-calendar-white.svg"
                      alt=""
                    />
                  </button>
                  {showDateRange && (
                    <div
                      ref={dateRangeRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: "0",
                        zIndex: 10,
                        background: "white",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => setState([item.selection])}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}
                </div>
              </h5>
              <p className="ff2 fz16">
                You can begin your assignment by uploading it in the format that
                works best for you—either as a document file (PDF or DOC) or as
                a QR image.
              </p>
              <div className="tabbing-outer">
                <div className="tabs">
                  <div
                    className={
                      `tab-btn-bg tab-btn-bg--one` +
                      (uploadedTab === null ? " defaultBtnState" : "") +
                      (uploadedTab === "file" ? " uploaded" : "")
                    }
                  >
                    <label
                      className={`w-100 border-0 tabs__tab${
                        uploadedTab === "file"
                          ? " uploaded"
                          : uploadedTab === null
                            ? " defaultBtnState"
                            : ""
                      }`}
                      tabIndex={-1}
                      onClick={() => setUploadedTab("file")}
                    >
                      <img
                        src="./assets/images/inner-pages/icons/icon-modal-upload.svg"
                        alt=""
                      />
                      <span className="ff2 fw500 fz18 text-nowrap">
                        Upload file{" "}
                        <small className="text-nowrap fz14 fw400">
                          <em>~max size 10mb, pdf,doc</em>
                        </small>
                      </span>
                      <input
                        type="file"
                        onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            setUploadedTab("file");
                            e.target.value = "";
                          }
                        }}
                      />
                    </label>
                  </div>
                  {/* QR Tab */}
                  <div
                    className={
                      `tab-btn-bg tab-btn-bg--two` +
                      (uploadedTab === null ? " defaultBtnState" : "") +
                      (uploadedTab === "qr" ? " uploaded" : "")
                    }
                  >
                    <label
                      className={`w-100 border-0 tabs__tab${
                        uploadedTab === "qr"
                          ? " uploaded"
                          : uploadedTab === null
                            ? " defaultBtnState"
                            : ""
                      }`}
                      tabIndex={-1}
                      onClick={() => setUploadedTab("qr")}
                    >
                      <img
                        src="./assets/images/inner-pages/icons/icon-modal-QR.svg"
                        alt=""
                      />
                      <span className="ff2 fw500 fz18 text-nowrap">
                        Upload QR{" "}
                        <small className="text-nowrap fz14 fw400">
                          <em>~max size 100KB,jpg,jpeg,png</em>
                        </small>
                      </span>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            setUploadedTab("qr");
                            e.target.value = "";
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="show-uploaded">
                  {/* For file upload hide/show  */}
                  <ul className="mb-0 list-inline files">
                    <li>
                      <div className="file">
                        <div className="fw400 name">
                          C# first assignment.pdf
                          <small className="ff2">
                            <em>~(1mb)</em>
                          </small>
                        </div>

                        <div className="action-btns">
                          <button className="btn btn-round btn-round--yellow">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-view-eye.svg"
                              alt="view"
                            />
                          </button>
                          <button className="btn btn-round btn-round--red">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-trash.svg"
                              alt="delete"
                            />
                          </button>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="file">
                        <div className="fw400 name">
                          C# first assignment.pdf
                          <small className="ff2">
                            <em>~(1mb)</em>
                          </small>
                        </div>

                        <div className="action-btns">
                          <button className="btn btn-round btn-round--yellow">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-view-eye.svg"
                              alt="view"
                            />
                          </button>
                          <button className="btn btn-round btn-round--red">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-trash.svg"
                              alt="delete"
                            />
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                  {/* For QR upload hide/show  */}
                  <ul className="mb-0 list-inline qrs">
                    <li>
                      <div className="qr">
                        <div className="fw400 name">
                          <img
                            src="./assets/images/inner-pages/icons/icon-modal-placeholder-qr.svg"
                            alt="qr preview"
                          />
                          <span>
                            0x707blo709lkh9809no08hblo709lkh980x707blo709lkh9809no08hblo709lkh98
                          </span>
                        </div>

                        <div className="action-btns">
                          <button className="btn btn-round btn-round--yellow">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-view-eye.svg"
                              alt="view"
                            />
                          </button>
                          <button className="btn btn-round btn-round--red">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-trash.svg"
                              alt="delete"
                            />
                          </button>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="qr">
                        <div className="fw400 name">
                          <img
                            src="./assets/images/inner-pages/icons/icon-modal-placeholder-qr.svg"
                            alt="qr preview"
                          />
                          <span>
                            0x707blo709lkh9809no08hblo709lkh980x707blo709lkh9809no08hblo709lkh98
                          </span>
                        </div>

                        <div className="action-btns">
                          <button className="btn btn-round btn-round--yellow">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-view-eye.svg"
                              alt="view"
                            />
                          </button>
                          <button className="btn btn-round btn-round--red">
                            <img
                              src="./assets/images/inner-pages/icons/icon-modal-trash.svg"
                              alt="delete"
                            />
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <button className="btn btn-solid btn-solid--dark">
            <span className="mx-auto">Generate</span>
          </button>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}